import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a7b4312c"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=a7b4312c&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports